import React from 'react'
import './ProPayge.css'
import axios from 'axios'
import { Helmet } from 'react-helmet'
import { Document, Page } from 'react-pdf/dist/entry.webpack'
import driveLogo from '../../assets/img/googledrive.png'

import Unsplash from 'unsplash-js'
import GooglePicker from 'react-google-picker'
import DropboxChooser from 'react-dropbox-chooser'
import * as firebase from "firebase/app"
import "firebase/auth"

import { API_URL } from '../../config'
import { themeColors } from '../../constants'
import PaygeItem from '../../components/PaygeItem/PaygeItem'
import { ArrowForward, Add, Close, CheckCircle } from '@material-ui/icons'

const options = {
  cMapUrl: 'cmaps/',
  cMapPacked: true,
};

// const img_one = "https://images.unsplash.com/photo-1561016444-14f747499547?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1489&q=80"
const default_background = {
  urls: {
    full: '',
    small: '',
  },
  user: {
    name: "...",
    links: { html: "#" }
  }
}

export default class ProPayge extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      isLoaded: false,
      paygeData: undefined,
      isBackgroundLoaded: false,
      isLinkCopied: false,
    }
  }

  // copying to clipboard
  copyLinkToClipboard = () => {
    let context = this
    let link = `https://payge.io/pro/${this.props.match.params.payge_id}`
    navigator.permissions.query({name: "clipboard-write"}).then(result => {
      if (result.state == "granted" || result.state == "prompt") {
        // writing link to clipboard
        navigator.clipboard.writeText(link).then(function() {
          console.log("clipboard copied")
          // quick UI changes
          context.showCopyUIChanges()
        }, function() {
          console.log("clipboard error")
        });
      }
    });
  }
  showCopyUIChanges = () => {
    this.setState({isLinkCopied: true})
    setTimeout(() => {
      this.setState({isLinkCopied: false})
    }, 700)
  }

  componentWillMount() {
    if (this.props.isEditing) { return }

    let paygeID = this.props.match.params.payge_id
    // showing loading indicator
    this.setState({isLoaded: false})
    console.log(paygeID)
    // getting payge details
    axios(`${API_URL}/payge/${paygeID}`)
      .then((result) => {
        if (result.status === 200) {
          if (result.data.status === "success") {
            document.title = `${result.data.payge.paygeDetails.name} - Payge`
            this.setState({
              paygeData: result.data.payge,
              isLoaded: true
            })
            // setting up google analytics
            if (result.data.payge.paygeDetails.gAnalyticsTrackingId) {
              this.setupGoogleAnalyticsForUser(result.data.payge.paygeDetails.gAnalyticsTrackingId)
            }
            // loading the background 
            const img = new Image()
            img.src = result.data.payge.backgroundImage.urls.small
            img.onload = () => {
              this.setState({
                isBackgroundLoaded: true
              })
            }
            // end of loading
          }
        }
      })
  }

  // Adding Google Analytics with User's tracking Id
  setupGoogleAnalyticsForUser(gAnalyticsTrackingId) {
    // adding scripts
    const script = document.createElement("script")
    script.src = `https://www.googletagmanager.com/gtag/js?id=${gAnalyticsTrackingId}`
    script.async = true
    document.body.appendChild(script)
    
		const gScriptTag = document.createElement("script")
    gScriptTag.innerHTML = 
    `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());

    gtag('config', '${gAnalyticsTrackingId}');
    `
    gScriptTag.async = true
    document.body.appendChild(gScriptTag)
  }

  render() {
    const { isLoaded, paygeData, isBackgroundLoaded, isLinkCopied } = this.state
    let { isEditing, selectedBackground, downloadFile, landingLogo, isLoading,
      themeColorName, sidebarStyle, isPublishError, landingTitle, landingDescription, fileName } = this.props

    let theme = isEditing && !isLoading ? 'four' : 'one'
    // getting theme color
    let currentThemeColor = themeColors[0]
    themeColors.map(color => {
      if (color.name == themeColorName) { currentThemeColor = color }
    })

    // loading
    isLoading = isEditing ? isLoading : !isLoaded

    // getting payge data
    let background = isEditing ? selectedBackground : undefined
    let name = undefined
    let title = undefined
    let description = undefined
    let logoUrl = undefined
    let landingLinks = this.props.landingLinks ? this.props.landingLinks : []
    let driveFile = isEditing ? downloadFile.driveFile : undefined
    let dropboxFile = isEditing ? downloadFile.dropboxFile : undefined
    let isPaid = false
    let paymentDetails = undefined
    let paygeId = isEditing ? '' : this.props.match.params.payge_id
    let isJustCreated = false
    if (paygeData) {
      // theme
      theme = 'four'
      // getting payge details
      background = paygeData.backgroundImage
      let paygeDetails = paygeData.paygeDetails
      name = paygeDetails.name
      title = paygeDetails.landing.title
      description = paygeDetails.landing.description
      landingLogo = paygeDetails.landing.logoUrl
      landingLinks = paygeDetails.landing.links ? paygeDetails.landing.links : []
      // getting the correct download file
      driveFile = paygeData.driveFile
      dropboxFile = paygeData.dropboxFile
      paygeId = paygeData.id
      // getting theme
      if (paygeData.isPaid) {
        isPaid = paygeData.isPaid
        paymentDetails = paygeData.paymentDetails
      }
      // getting color and sidebar style
      themeColors.map(color => {
        if (color.name == paygeDetails.landing.themeColor) { currentThemeColor = color }
      })
      sidebarStyle = paygeDetails.landing.sidebarStyle
      // checking if payge is just created
      let new_payge_tag = new URLSearchParams(this.props.location.search).get('new_payge')
      if (paygeData.viewCount === 0 && new_payge_tag) {
        isJustCreated = true
      }
    }

    let app_styles = 'propayge app'
    let pageTitle = 'Loading'
    if (name) { pageTitle = name }

    let paygeItem = (
      <PaygeItem 
        theme={theme} 
        isLoaded={isEditing ? !isLoading: isLoaded}
        isDemo={isEditing}
        isEditing={isEditing}
        isPublishError={isPublishError}
        name={name} 
        description={description} 
        driveFile={driveFile}
        dropboxFile={dropboxFile}
        paygeId={paygeId}
        isPaid={isPaid}
        background={background}
        onChangeBackground={this.props.onChangeBackground}
        isBackgroundChooserOpen={this.props.isBackgroundChooserOpen}
        paymentDetails={paymentDetails}
        onDownloadFileChange={this.props.onDownloadFileChange}
        isBackgroundLoaded={isBackgroundLoaded}
        // input properties
        fileNameInput={this.props.fileName}
        onFileNameChange={this.props.onFileNameChange} />
    )

    let meta_image = background ? background.urls.small : ""

    return (
      <div className={`${app_styles}`}>

        {
          !isEditing ? (
            <Helmet>
              <title>{`${pageTitle} — Payge Pro`}</title>
              <meta name="description" content={description} />

              {/* Google / Search Engine Tags */}
              <meta itemprop="name" content={`${pageTitle} — Payge Pro`} />
              <meta itemprop="description" content={description} />
              <meta itemprop="image" content={meta_image} />

              {/* Facebook Meta Tags */}
              <meta property="og:url" content={`https://payge.io/pro/${paygeId}`} />
              <meta property="og:type" content="website" />
              <meta property="og:title" content={`${pageTitle} — Payge Pro`} />
              <meta property="og:description" content={description} />
              <meta property="og:image" content={meta_image} />

              {/* Twitter Meta Tags */}
              <meta name="twitter:card" content="summary_large_image" />
              <meta name="twitter:title" content={`${pageTitle} — Payge Pro`} />
              <meta name="twitter:description" content={description} />
              <meta name="twitter:image" content={meta_image} />
            </Helmet>
          ) : false
        }

        <div className="landing-content">
          {
            true && !isLoading ? (
              <>
                {
                  isEditing && !landingLogo ? (
                    <>
                      <input 
                        type="file" 
                        accept="image/x-png,image/gif,image/jpeg"
                        onChange={(e)=>this.props.handleLandingLogoChange(e)} style={{display:'none'}}
                        ref={(ref) => this.logoInput = ref} />
                      <div className="add-logo-container" type="submit" onClick={()=>this.logoInput.click()}>
                        <Add className="icon"/>Add Logo (optional)
                      </div>
                    </>
                  ) : isEditing && landingLogo ? (
                    <>
                      <input type="file" onChange={(e)=>this.props.handleLandingLogoChange(e)} style={{display:'none'}}
                        ref={(ref) => this.logoInput = ref} />
                      <img src={URL.createObjectURL(landingLogo)} className="landing-logo hoverable" onClick={()=>this.logoInput.click()} />
                    </>
                  ) : landingLogo ? (
                    <img src={landingLogo} className="landing-logo" />
                  ): false
                }
                { 
                  isEditing ? (
                    <>
                      <div 
                        id="landing-title-input"
                        contentEditable 
                        onInput={(e)=>this.props.onLandingTitleChange(e.target.textContent)}
                        placeholder="Start typing a title here..."
                        className={ isPublishError ? "landing-title textarea error" : "landing-title textarea"}>
                        {/* {landingTitle} */}
                      </div>
                      <div 
                        id="landing-description-input"
                        contentEditable 
                        onInput={(e)=>this.props.onLandingDescriptionChange(e.target.textContent)}
                        placeholder="Type in your description here..."
                        className={ isPublishError ? "landing-description textarea error" : "landing-description textarea"}>
                        {/* {landingDescription} */}
                      </div>

                      <div className="landing-actions">
                        <ul className="links-list">
                          {
                            landingLinks.map((link, index) => {
                              return (
                                <li 
                                  className="none"
                                  style={{
                                    color: `rgb(${currentThemeColor.color[0]},${currentThemeColor.color[1]}, ${currentThemeColor.color[2]})`
                                  }}>
                                  <a href={link.link} target="_blank"><span>{link.name}</span>
                                  <ArrowForward className="link-icon"/></a>
                                  <Close className="link-icon gray" onClick={this.props.onLinkRemove.bind(this, index)}/>
                                </li>
                              )
                            })
                          }
                          {
                            landingLinks.length < 3 ? (
                              <li className="new" onClick={this.props.onLinkAddClick.bind(this)}
                                style={{
                                  color: `rgb(${currentThemeColor.color[0]},${currentThemeColor.color[1]}, ${currentThemeColor.color[2]})`,
                                  background: `rgb(${currentThemeColor.color[0]},${currentThemeColor.color[1]}, ${currentThemeColor.color[2]}, 0.05)`
                                }}>
                                <span>Add External Link</span><Add className="link-icon"/>
                              </li>
                            ): false
                          }
                        </ul>
                      </div>
                    </>
                  ) : (
                    <>
                      <span className="landing-title">{title}</span>
                      <span className="landing-description">{description}</span>

                      <div className="landing-actions">
                        <ul className="links-list">
                          {
                            landingLinks.map((link, index) => {
                              return (
                                <li className="active"
                                  style={{
                                    color: `rgb(${currentThemeColor.color[0]},${currentThemeColor.color[1]}, ${currentThemeColor.color[2]})`
                                  }}>
                                  <a href={link.link} target="_blank"><span>{link.name}</span>
                                  <ArrowForward className="link-icon"/></a>
                                </li>
                              )
                            })
                          }
                        </ul>
                      </div>
                    </>
                  )
                }
              </>
            ) : true && isLoading ? (
              <div class="pro-shimmer-container" style={{padding: '25px 30px'}}>
                <div className="description shimmer short" />
                <br/>
                <div className="description shimmer" />
                <div className="description shimmer" />
                <br/>
                <div style={{display:'flex'}}>
                  <div className="name shimmer" /><div className="name shimmer" />
                </div>
              </div>
            ) : (
              <>
                <div className="pdf-preview">
                  <img src={"https://yashlabs.co/static/media/logo.afe6b25b.png"} className="landing-logo" />
                  <span className="landing-title">This is something new we're working on!</span>
                  <span className="landing-description">We're putting our brains and thoughts into building a landing pages for downloads solution. Let us know what you think about this new design! </span>
                  <div className="landing-actions">
                    <ul className="links-list">
                      <a href="https://payge.io">
                        <li><span>Go to X Home</span><ArrowForward className="link-icon"/></li>
                      </a>
                      <a href="https://payge.io/dashboard">
                        <li><span>Go to X Dashboard</span><ArrowForward className="link-icon"/></li>
                      </a>
                    </ul>
                  </div>

                  <span className="preview-title">Document Preview</span>
                  <Document 
                    file={paygeData ? paygeData.driveFile.downloadUrl : false}
                    options={options}
                    renderMode="svg"
                    className="pdf-document">
                    <Page pageNumber={1} />
                  </Document>
                  <span className="download-to-view">Download to view full file</span>
                </div>
              </>
            )
          }

        </div>

        <div className={sidebarStyle === "straight" ? "page-bg straight" : "page-bg"}
          style={{
            background: `rgb(${currentThemeColor.color[0]},${currentThemeColor.color[1]}, ${currentThemeColor.color[2]})`,
            background: `linear-gradient(90deg, 
              rgba(${currentThemeColor.gradient[0][0]},${currentThemeColor.gradient[0][1]}, ${currentThemeColor.gradient[0][2]}, ${currentThemeColor.gradient[0][3]}) 0%, 
              rgba(${currentThemeColor.gradient[1][0]},${currentThemeColor.gradient[1][1]}, ${currentThemeColor.gradient[1][2]}, ${currentThemeColor.gradient[1][3]}) 25%, 
              rgba(${currentThemeColor.gradient[2][0]},${currentThemeColor.gradient[2][1]}, ${currentThemeColor.gradient[2][2]}, ${currentThemeColor.gradient[2][3]}) 100%)`
          }} />

        {
          background && (driveFile || dropboxFile) ? (
            <div className="img-attribution">
              <span>
                Photo by <a href={`${background.user.links.html}?utm_source=payge&utm_medium=referral`} target="_blank">{background.user.name}</a> on <a href="https://unsplash.com/?utm_source=payge&utm_medium=referral" target="_blank">Unsplash</a>
              </span>
            </div>
          ) : false
        }
      
        {
          (!driveFile && !dropboxFile && isEditing && !isLoading) ? (
            <>
              <div className={ isPublishError ? "add-file-container error" : "add-file-container"}>
                <span className="add-file-title">Add download file</span>
                <span className="add-file-des">Select a file stored in any of the following cloud storage providers</span>
                <ul className="pro-file-providers">
                  <GooglePicker 
                    clientId={'678604044547-incnhojndefjdjv63md3fsbk5vo0ccvc.apps.googleusercontent.com'}
                    developerKey={'AIzaSyDrDdmRMzPZdInG6O9uTVrfslh82gXBcAc'}
                    scope={['https://www.googleapis.com/auth/drive.file']}
                    onChange={data => this.props.onDriveSelectDataChange(data)}
                    onAuthFailed={data => console.log('on auth failed:', data)}
                    multiselect={false}
                    navHidden={false}>
                    <li className={this.props.cloudButtonStyles.driveStyles}>
                      <img src={driveLogo}/>
                      <span>Google Drive</span>
                    </li>
                  </GooglePicker>
                  <DropboxChooser 
                    appKey={'cjwxs1ps6pj49sq'}
                    success={files => this.props.onDropboxChooseDataChange(files)}
                    linkType={'direct'} >
                    <li className={this.props.cloudButtonStyles.dropboxStyles}>
                      <img src={"https://cfl.dropboxstatic.com/static/images/logo_catalog/dropbox_logo_glyph_m1.svg"}/>
                      <span>Dropbox</span>
                    </li>      
                  </DropboxChooser>
                </ul>
              </div>
            </>
          ): 

          paygeItem
        }

        {
          isJustCreated ? (
            <div className="created-banner">
              <CheckCircle className="icon" />
              <span className="done-text">Start sharing your newly created Pro Payge!</span>
              <span className="copy-btn" onClick={this.copyLinkToClipboard.bind(this)}>{ isLinkCopied ? 'Copied' : 'Copy Link to Clipboard'}</span>
            </div>
          ): false
        }

      </div>

    )
  }

}